import React, { useContext } from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { TabsContext } from '../context';

export default function Tab({ label = '', value = null, disabled = false }) {
  const {
    activeValue = null,
    isDisabled = false,
    tabClassName = '',
    activeTabClassName = '',
    onChange = () => {}
  } = useContext(TabsContext);

  const isTabDisabled = isDisabled || disabled;

  return (
    <span
      role="button"
      onClick={() => !isTabDisabled && onChange(value)}
      data-active={activeValue === value}
      data-disabled={isTabDisabled}
      className={cn(
        styles.pill,
        { [activeTabClassName]: !!activeTabClassName && activeValue === value },
        tabClassName
      )}
    >
      {label}
    </span>
  );
}
